import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Berries.css";

export default function Berries() {
    const berriesProducts = [
        {
            id: 1,
            name: "DRIED CRANBERRIES",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Cranberries.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Breakfast cereals",
                        "Trail mixes",
                        "Healthy snack foods",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Sweet and tangy flavor",
                        "Rich in antioxidants",
                        "Popular health food ingredient",
                        "Long shelf life",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "DRIED BLUEBERRIES",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Blueberries.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Breakfast cereals",
                        "Snack bars",
                        "Dessert preparations",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "High antioxidant content",
                        "Natural sweetness",
                        "Premium fruit ingredient",
                        "Rich nutritional value",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "DRIED CHERRIES",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Cherries.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Desserts",
                        "Chocolate manufacturing",
                        "Snack mixes",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich fruity flavor",
                        "Natural sweetness",
                        "Premium ingredient",
                        "High antioxidant value",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "DRIED STRAWBERRIES",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Strawberries.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Ice cream toppings",
                        "Bakery products",
                        "Chocolate industry",
                        "Snack foods",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Sweet fruity flavor",
                        "Attractive appearance",
                        "Consumer favorite",
                        "Premium quality ingredient",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "DRIED KIWI",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Kiwi.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Healthy snack packs",
                        "Breakfast cereals",
                        "Dessert toppings",
                        "Fruit mixes",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Unique sweet-tart flavor",
                        "Rich in vitamins",
                        "Colorful appearance",
                        "Premium dried fruit",
                    ],
                },
            ],
        },

        {
            id: 6,
            name: "DRIED MANGO",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Mango.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack products",
                        "Fruit mixes",
                        "Bakery items",
                        "Desserts",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Naturally sweet taste",
                        "Rich tropical flavor",
                        "Popular dried fruit",
                        "High consumer demand",
                    ],
                },
            ],
        },

        {
            id: 7,
            name: "DRIED PINEAPPLE",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Pineapple.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snack foods",
                        "Bakery products",
                        "Fruit blends",
                        "Confectionery items",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Sweet tropical flavor",
                        "Chewy texture",
                        "Popular fruit ingredient",
                        "Long shelf life",
                    ],
                },
            ],
        },

        {
            id: 8,
            name: "DRIED PAPAYA",
            image: "/assets/img/Berries & Exotic Dried Fruits/Dried-Papaya.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Breakfast cereals",
                        "Fruit mixes",
                        "Bakery products",
                        "Healthy snacks",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Bright color and flavor",
                        "Rich nutritional value",
                        "Easy to consume",
                        "Popular dried fruit option",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Berries"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Berries Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality dried berries sourced from trusted
                        suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {berriesProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}